/* ══════════════════════════════════════════════
   by Mariam Assem — Theme JS
   ══════════════════════════════════════════════ */

/* Scroll reveal observer */
const revealObs = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      revealObs.unobserve(e.target);
    }
  });
}, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

/* Fallback: make all reveal elements visible after 1.5s in case observer fails */
setTimeout(() => {
  document.querySelectorAll('.reveal').forEach(el => el.classList.add('visible'));
}, 1500);

/* Global wishlist toggle */
document.querySelectorAll('.wl').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    btn.textContent = btn.textContent === '♡' ? '♥' : '♡';
  });
});

/* Cart AJAX add feedback */
document.querySelectorAll('form[action*="cart/add"]').forEach(form => {
  form.addEventListener('submit', function(e) {
    const btn = form.querySelector('.btn-add');
    if (!btn) return;
    const original = btn.textContent;
    btn.textContent = 'Added ✦';
    btn.style.background = 'var(--gold)';
    setTimeout(() => {
      btn.textContent = original;
      btn.style.background = '';
    }, 2000);
  });
});
